import { render } from "./klb-tail.vue?vue&type=template&id=2920f24a&scoped=true"
import script from "./klb-tail.vue?vue&type=script&lang=js"
export * from "./klb-tail.vue?vue&type=script&lang=js"

import "./klb-tail.vue?vue&type=style&index=0&id=2920f24a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2920f24a"]])

export default __exports__